import { SamplePack } from '@arpeggi/shared'
import axios from '../../../__legacy__/lib/axios'

export const getOneSamplePack = async (id: number) => {
  const { data } = await axios.get<SamplePack>(`/api/v2/sample-packs/${id}`)

  return data
}
